/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export class ObjectHelpers {
  static isLastElement = (index: number, length: number) => {
    return index + 1 === length
  }

  // This is a helper function so that `Object.keys(object)` can return the literal keys,
  // so we don't have to do `as <Type>` every now and then.
  //
  // TODO: use this across all UIs -- we can use the keyword Object.keys(), probably there are a lot of it.
  static keys = <TObjectType extends object>(value: TObjectType) => {
    return Object.keys(value) as Array<keyof TObjectType>
  }

  // TODO: since this is only used for tests, maybe it's better if we have `TestUtils` or some sort, so that
  // we don't bring this to production builds.
  static cloneObject = <TObjectType>(obj: TObjectType): TObjectType => {
    return JSON.parse(JSON.stringify(obj))
  }

  /**
   * This is for removing keys that contain undefined or empty string values
   */
  static cleanObject = <TObjectType extends Record<string, unknown>>(obj: TObjectType): TObjectType => {
    const newObject = ObjectHelpers.cloneObject(obj)
    ObjectHelpers.keys(newObject).forEach(key => {
      if (newObject[key] === undefined || newObject[key] === '') {
        delete newObject[key]
      }
    })
    return newObject
  }
}
